var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(45 16.914 14.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.293,
    r: 10.5,
    fill: "#38424A",
    stroke: "#FFF",
    transform: "rotate(45 15 15.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 11,
    x: 14,
    y: 10,
    fill: "#FFF",
    rx: 1,
    transform: "rotate(180 15 15.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 11,
    x: 14,
    y: 10,
    fill: "#FFF",
    rx: 1,
    transform: "rotate(-90 15 15.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBtn);
export default __webpack_public_path__ + "static/media/cancel-btn.8769eb222eb2b9f4e5ac19406522c718.svg";
export { ForwardRef as ReactComponent };